<template>
    <b-card class="calculator">
        <div slot="header"
             class="font-weight-bold"
        >
            <i class="fa fa-calculator"/>
            Productos
        </div>

        <!-- Filtros -->
        <b-row>
            <b-col lg="3"
                   md="6"
                   class="mb-1"
            >
                <label for="company_id">Empresa</label>
                <el-select v-model="filters.company_id"
                           id="company_id"
                           name="company_id"
                           filterable
                           remote
                           clearable
                           size="small"
                           placeholder="Seleccione una empresa"
                           class="el-select-input-group w-100"
                           no-data-text="No hay datos que coincidan"
                           no-match-text="No hay datos que coincidan"
                           :remote-method="getCompaniesFilters"
                           @change="getProducts"
                >
                    <el-option v-for="company in companies_filters"
                               :key="company.id"
                               :label="company.nombre"
                               :value="company.id"
                    />
                </el-select>
            </b-col>

            <!-- Nombre -->
            <b-col lg="3"
                   md="6"
                   class="mb-1"
            >
                <label for="name">Nombre</label>
                <el-input id="name"
                          name="name"
                          size="small"
                          type="text"
                          v-model="filters.name"
                />
            </b-col>

            <!-- Fabricante -->
            <b-col lg="3"
                   md="6"
                   class="mb-1"
            >
                <label for="filter">Fabricante</label>
                <el-select id="manufacturer_id"
                           name="manufacturer_id"
                           v-model="filters.manufacturer_id"
                           size="small"
                           filterable
                           remote
                           :remote-method="getManufacturersFilters"
                           clearable
                           no-data-text="No hay datos que coincidan"
                           no-match-text="No hay datos que coincidan"
                >
                    <el-option v-for="manufacturer in manufacturers_filters"
                               :key="manufacturer.id"
                               :label="manufacturer.nombre"
                               :value="manufacturer.id"
                    />
                </el-select>
            </b-col>

            <!-- Botones -->
            <b-col lg="3"
                   md="6"
                   class="text-nowrap pl-lg-0 mb-1 mt-md-0 mt-1"
            >
                <label class="w-100 d-none d-md-block mb-md-1">&nbsp;</label>
                <b-button-group size="md">
                    <b-button @click="getProducts(true)"
                              variant="primary"
                              size="sm"
                    >
                        <i class="fa fa-search fa-lg"></i>
                        Buscar
                    </b-button>
                    <b-button @click="_resetFilters()"
                              size="sm"
                    >
                        <i class="fa fa-eraser fa-lg"></i>
                        Limpiar
                    </b-button>

                </b-button-group>

                <b-button @click="openModalForCreation()"
                          variant="primary"
                          class="float-right"
                          size="sm"
                          :disabled="!filters.company_id"
                >
                    <i class="fa fa-plus"></i> Crear
                </b-button>
            </b-col>
        </b-row>

        <!-- Tabla -->
        <b-row class="mt-2">
            <b-col>
                <b-table responsive
                         hover
                         striped
                         thead-class="table-active"
                         show-empty
                         small
                         empty-text="No hay productos para mostrar"
                         :items="products.data"
                         :fields="columns"
                         :tbody-tr-class="getClassRow"
                >
                    <template v-slot:cell(name)="data">
                        {{ data.item.name }} <br>
                        <b-badge v-if="data.item.state && data.item.state.lista"
                                 :variant="getVariantState(data.item.state.lista)"

                                 class="small text-black-50"
                        >
                            {{ data.item.state.lista }}
                        </b-badge>
                    </template>
                    <template v-slot:cell(actions)="data">

                        <el-tooltip effect="dark"
                                    placement="top"
                                    content="Eliminar producto"
                                    popper-class="py-1 px-2"
                        >
                            <b-button variant="danger"
                                      class="float-right mr-1"
                                      size="sm"
                                      @click="deleteProduct(data.item)"
                            >
                                <i class="fa fa-trash"/>
                            </b-button>
                        </el-tooltip>

                        <el-tooltip effect="dark"
                                    placement="top"
                                    content="Editar producto"
                                    popper-class="py-1 px-2"
                        >
                            <b-button variant="primary"
                                      class="float-right mr-1"
                                      size="sm"
                                      @click="openDetailProduct(data.item)"
                            >
                                <i class="fa fa-edit"/>
                            </b-button>
                        </el-tooltip>

                        <el-tooltip effect="dark"
                                    placement="top"
                                    content="Ver producto"
                                    popper-class="py-1 px-2"
                        >
                            <b-button variant="info"
                                      class="float-right mr-1"
                                      size="sm"
                                      :to="`/calculadora/producto/${data.item.id}/${data.item.slq_company_id}/1`"
                            >
                                <i class="fa fa-eye"/>
                            </b-button>
                        </el-tooltip>
                    </template>
                </b-table>
                <el-pagination class="float-right"
                               v-model="filters.page"
                               :total="products.total"
                               :page-sizes="[15, 30, 50, 100]"
                               :current-page.sync="filters.page"
                               :page-size.sync="filters.per_page"
                               layout="total,sizes, prev, pager, next"
                               @size-change="getProducts(true)"
                               @current-change="getProducts()"
                />
            </b-col>
        </b-row>

        <!-- Modal de creación y edición -->
        <modal ref="modal_product"/>

        <!-- Modal de creación de fabricante -->
        <modal_manufacturer/>
    </b-card>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex';
import modal from './modal';
import modal_manufacturer from './modal_manufacturer';
import {getAcls, validarRol} from '../../plugins/acl';

export default {
    name: 'index',
    components: {
        modal,
        modal_manufacturer
    },
    data() {
        return {
            show_filter_company: false
        };
    },
    computed: {
        ...mapState('productsCalculator', [
            'product',
            'products',
            'filters',
            'manufacturers_filters',
            'companies_filters'
        ]),
        columns() {
            let columns = [
                {
                    key: 'name',
                    label: 'Nombre'
                },
                {
                    key: 'manufacturer.nombre',
                    label: 'Fabricante'
                },
                {
                    key: 'actions',
                    label: ''
                }
            ];

            if (!this.filters.company_id) {
                columns.unshift({
                    key: 'company.nombre',
                    label: 'Empresa'
                });
            }

            return columns;
        }
    },
    async created() {
        const acls = getAcls();

        this.setPaginateFilter(true);

        this.show_filter_company = !!acls.roles.filter(r => ['superadmin', 'admin', 'admin-tecnico'].includes(r)).length;

        if (!this.show_filter_company) {
            const company_id = await this.obtenerIdEmpresaUsuario();

            this.setCompanyIdFilter(company_id);
        }

        await this.getProducts(true);

        this.load(false);
    },
    methods: {
        ...mapActions('productsCalculator', [
            'getProducts',
            'getProductCompany',
            'getManufacturersFilters',
            'getCompaniesFilters',
            'deleteProduct'
        ]),
        ...mapActions('dashboard', ['obtenerIdEmpresaUsuario']),
        ...mapMutations('productsCalculator', [
            'setModalShow',
            'resetFilters',
            'setCompanyIdFilter',
            'setPaginateFilter',
            'setAction',
            'setProduct',
            'setManufacturers',
            'resetProduct'
        ]),
        ...mapMutations('dashboard', ['load']),
        async openDetailProduct(product) {
            await this.getProductCompany(product);
            await this.$router.push(`/calculadora/producto/${this.product.id}/${this.product.slq_company_id}`);
        },
        getVariantState(state) {
            switch (state) {
                case 'Liquido':
                    return 'info';
                case 'Gaseoso':
                    return 'secondary';
                case 'Solido':
                    return 'light';
                default:
                    return '';
            }
        },
        getClassRow(item) {
            if (!!item && item.raw_materials_count === 0) return 'table-danger';
        },
        openModalForCreation() {
            this.resetProduct();
            this.$refs.modal_product.change = false;
            this.setAction('Crear');
            this.setModalShow(true);
        },
        openModalForEdition(product) {
            this.$refs.modal_product.change = false;
            this.setAction('Editar');
            this.setModalShow(true);
            this.setProduct(JSON.parse(JSON.stringify(product)));
            if (product.manufacturer) {
                this.setManufacturers([product.manufacturer]);
            } else {
                this.setManufacturers([]);
            }
        },
        _resetFilters() {
            this.resetFilters();
            this.getProducts();
        }
    },
};
</script>

<style lang="scss"
       src="../../assets/calculator.scss"
/>
